import { render, staticRenderFns } from "./JsaIndex.vue?vue&type=template&id=61cef413"
import script from "./JsaIndex.vue?vue&type=script&lang=js"
export * from "./JsaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports